import styled from 'styled-components';

export const Heading = styled.h1`
  font-size: 35px;
  font-weight: 600;
  margin: 40px 0px;
`;

export const HeadingNoMargin = styled.h1`
  font-size: 35px;
  font-weight: 600;
`;

export const SubHeading = styled.h2`
  font-size: 45px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const PageTitle = styled.h1`
  font-weight: 800;
  font-size: 26px;
`;

export const SmallTitle = styled.div`
  color: #3f456f;
  font-size: 14px;
  font-weight: 500;
`;

export const NormalText = styled.p`
  font-size: 15px;
  font-weight: 300;
`;

export const Paragraph = styled.p`
  color: #384277;
  font-weight: 400;
  font-size: 14px;
`;

export const LightParagraph = styled.p`
  font-size: 14px;
  color: #9092c1;
`;

export const ParagraphLink = styled.a`
  color: #9092c1;
  text-decoration: underline;
  cursor: pointer;
`;

export const ChargeType = styled.span`
  font-weight: 600;
  color: #5d6ef8;
  text-transform: uppercase;
`;
